import { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase/config";
import { C, F, Label, Rule, KPI, Spinner } from "../ui";
import { fmtUSD, calcMargen } from "../../utils/ddp";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [prodsSnap, usersSnap] = await Promise.all([
        getDocs(collection(db, "productos")),
        getDocs(collection(db, "usuarios")),
      ]);
      const prods = prodsSnap.docs.map(d => d.data());
      const users = usersSnap.docs.map(d => d.data());

      const totalProductos = prods.length;
      const publicados     = prods.filter(p => p.publicado !== false).length;
      const utilTotal      = prods.reduce((s, p) => {
        const m = calcMargen(p.fob_compra, p.fob_venta);
        return s + (m?.util || 0);
      }, 0);
      const compradores = users.filter(u => u.rol === "comprador").length;
      const admins      = users.filter(u => u.rol === "admin").length;

      setStats({ totalProductos, publicados, compradores, admins, utilTotal, usuarios: users.length });
      setLoading(false);
    };
    load();
  }, []);

  if (loading) return <Spinner />;

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <div style={{ fontFamily: F.serif, fontSize: 28, color: C.white, marginBottom: 6 }}>
          Panel de control
        </div>
        <div style={{ fontFamily: F.mono, fontSize: 10, color: C.muted }}>
          {new Date().toLocaleDateString("es-AR", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "0.5px", background: C.border, marginBottom: 24 }}>
        <KPI label="Productos en catálogo" value={stats.totalProductos} sub={`${stats.publicados} publicados`} />
        <KPI label="Usuarios registrados"  value={stats.usuarios}       sub={`${stats.compradores} compradores`} />
        <KPI label="Margen bruto catálogo" value={fmtUSD(stats.utilTotal)} sub="Suma utilidades FOB" valueColor={C.green} />
        <KPI label="Admins activos"        value={stats.admins} />
      </div>

      {/* Estado del sistema */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
        <div style={{ background: C.s1, border: `0.5px solid ${C.border}`, padding: 24 }}>
          <Label style={{ marginBottom: 16 }}>Estado del sistema</Label>
          {[
            ["Firebase Auth",       "Conectado",    C.green],
            ["Firestore DB",        "Conectado",    C.green],
            ["Ciclo activo",        "Sin ciclo abierto", C.muted],
            ["Tipo de cambio",      "Manual — actualizar", C.amber],
          ].map(([label, val, col]) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: `0.5px solid ${C.border}` }}>
              <span style={{ fontFamily: F.sans, fontSize: 12, color: C.muted }}>{label}</span>
              <span style={{ fontFamily: F.mono, fontSize: 10, color: col }}>{val}</span>
            </div>
          ))}
        </div>

        <div style={{ background: C.s1, border: `0.5px solid ${C.border}`, padding: 24 }}>
          <Label style={{ marginBottom: 16 }}>Próximos pasos</Label>
          {[
            ["1", "Cargar productos al catálogo",       "productos"],
            ["2", "Configurar categorías de la landing","categorias"],
            ["3", "Abrir primer ciclo de contenedor",   "ciclos"],
            ["4", "Invitar primeros compradores",        "usuarios"],
          ].map(([n, label]) => (
            <div key={n} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: `0.5px solid ${C.border}` }}>
              <span style={{ fontFamily: F.mono, fontSize: 10, color: C.muted, width: 16 }}>{n}</span>
              <span style={{ fontFamily: F.sans, fontSize: 12, color: C.off }}>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
